// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1qDVK","title":"Info_title__Wuw8N","links":"Info_links__28l1M","link":"Info_link__LPjuT","logo":"Info_logo__8OLjn"};